import {ChangeEvent, FC} from 'react';
import {extractCardDigits, formatCardDisplay} from '../../model';
import {StepLayout} from 'features/registration';
import {TextInput} from '../components/TextInput';
import styles from './PaymentDetailsStep.module.css';

type Props = {
	value: string;
	onChange: (cardDigits: string) => void;
};

export const PaymentCardStep: FC<Props> = ({value, onChange}) => {
	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange(extractCardDigits(event.target.value));
	};

	return (
		<StepLayout variant="fill">
			<StepLayout.Intro
				title="Введите номер карты"
				subtitle="С каждой выплаты на карту берётся комиссия 0,5% за нашу работу"
				compact
				subtitleMuted
			/>

			<StepLayout.Content className={styles.field}>
				<TextInput
					name="paymentCard"
					className={styles.input}
					value={formatCardDisplay(value)}
					placeholder="0000 0000 0000 0000"
					inputMode="numeric"
					autoComplete="cc-number"
					autoFocus
					onChange={handleChange}
					onClear={() => onChange('')}
				/>
			</StepLayout.Content>
		</StepLayout>
	);
};
